'use strict';

export const COLS = 10;
export const ROWS = 20;
export const BLOCK_SIZE = 30;

export const COLORS = [
    '#00f5ff', // cyan
    '#0000ff', // blue
    '#ff8c00', // orange
    '#ffff00', // yellow
    '#00ff00', // green
    '#800080', // purple
    '#ff0000'  // red
];

Object.freeze(COLORS);

export const KEY = {
    SPACE: 'Space',
    LEFT: 'ArrowLeft',
    RIGHT: 'ArrowRight',
    DOWN: 'ArrowDown',
    UP: 'ArrowUp',
    ROTATE: 'KeyZ'
};

Object.freeze(KEY);

export const PIECES = {
    I: {
        shape: [
            [0, 0, 0, 0],
            [1, 1, 1, 1],
            [0, 0, 0, 0],
            [0, 0, 0, 0]
        ],
        color: COLORS[0]
    },
    J: {
        shape: [
            [1, 0, 0],
            [1, 1, 1],
            [0, 0, 0]
        ],
        color: COLORS[1]
    },
    L: {
        shape: [
            [0, 0, 1],
            [1, 1, 1],
            [0, 0, 0]
        ],
        color: COLORS[2]
    },
    O: {
        shape: [
            [1, 1],
            [1, 1]
        ],
        color: COLORS[3]
    },
    S: {
        shape: [
            [0, 1, 1],
            [1, 1, 0],
            [0, 0, 0]
        ],
        color: COLORS[4]
    },
    T: {
        shape: [
            [0, 1, 0],
            [1, 1, 1],
            [0, 0, 0]
        ],
        color: COLORS[5]
    },
    Z: {
        shape: [
            [1, 1, 0],
            [0, 1, 1],
            [0, 0, 0]
        ],
        color: COLORS[6]
    }
};

Object.freeze(PIECES);